import React, { FC, useEffect } from 'react';
import { useUser } from '../../../shared';
import { StudentBookmarkIndicator } from './StudentBookmarkIndicator';
import { TeacherBookmarkIndicator } from './TeacherBookmarkIndicator';
import { useAppDispatch } from 'src/modules/shared/hooks/useAppDispatch';
import { setBookmarkMode } from 'src/modules/shared/slices/bookmark/entity/bookmarkEntity';
import { BookmarkModeEnum } from 'src/modules/shared/constants';

type BookmarkIndicatorProps = {
  blockId: string;
  className?: string;
};

export const BookmarkIndicator: FC<BookmarkIndicatorProps> = ({ blockId, className }) => {
  const dispatch = useAppDispatch();
  const { isStudent, isTeacher } = useUser();

  useEffect(() => {
    return () => {
      dispatch(setBookmarkMode(BookmarkModeEnum.DISABLED));
    };
  }, [dispatch]);

  if (!isStudent && !isTeacher) return null;

  return isStudent ? (
    <StudentBookmarkIndicator blockId={blockId} className={className} />
  ) : (
    <TeacherBookmarkIndicator blockId={blockId} className={className} />
  );
};
